/* eslint-disable react/prop-types */
import React from 'react';
import { FormControl, InputLabel, Select, MenuItem } from '@mui/material';

const HighwayDropdown = ({ onChange, value, highwayKeys }) => {

  return (
    <FormControl className={'w-full'}>
      <InputLabel id="type-route-label">Highway</InputLabel>
      <Select
        labelId="type-route-label"
        value={value || null}
        placeholder="Select Highway"
        onChange={evt => onChange(evt.target.value)}
        fullWidth>
        {highwayKeys.map(highway => {
          return <MenuItem value={highway}>{highway}</MenuItem>;
        })}
      </Select>
    </FormControl>
  );
};

export default HighwayDropdown;
